module.exports = __webpack_public_path__ + "8ffa91cf3bbb50d181ed21325709be12.woff";